import {
  CenarioMetadataResponse,
  CenarioValorItem,
  TipoCenario
} from '../types'
import { doDiaCivil, paraDiaCivil } from '../utils/vigencia'

function isBooleanoSN(
  metadata: CenarioMetadataResponse | null,
  tipo: string,
  chave: string
) {
  return (
    metadata?.tipos[tipo as TipoCenario]?.chaves.find(c => c.chave === chave)
      ?.dominio.tipo === 'booleano-sn'
  )
}

export function toFormValues(
  entity: any,
  metadata: CenarioMetadataResponse | null
) {
  const valoresObjeto: Record<string, any> = {}

  ;(entity.valores || []).forEach((item: CenarioValorItem) => {
    valoresObjeto[item.chave] = isBooleanoSN(metadata, entity.tipo, item.chave)
      ? item.valor === 'S'
      : item.valor
  })

  // Chave opcional em branco não é gravada: sem isto o campo abriria sem valor (não controlado).
  const chaves = metadata?.tipos[entity.tipo as TipoCenario]?.chaves ?? []
  chaves.forEach(chave => {
    if (!(chave.chave in valoresObjeto)) {
      valoresObjeto[chave.chave] =
        chave.dominio.tipo === 'booleano-sn' ? false : ''
    }
  })

  return {
    ...entity,
    dataInicio: entity.dataInicio ? doDiaCivil(entity.dataInicio) : null,
    dataFim: entity.dataFim ? doDiaCivil(entity.dataFim) : null,
    valores: valoresObjeto,
    condicoes: (entity.condicoes || []).map((c: any) => ({ ...c })),
    _novaCondicaoTipo: '',
    _novaCondicaoValor: null
  }
}

export function toPayload(values: any) {
  const {
    _novaCondicaoTipo,
    _novaCondicaoValor,
    id,
    codigo,
    ativo,
    condicoes,
    valores,
    dataInicio,
    dataFim,
    ...rest
  } = values

  return {
    ...rest,
    // Só o dia (yyyy-MM-dd): a hora que o seletor mantém e o fuso não podem mudar a data gravada.
    dataInicio: dataInicio ? paraDiaCivil(dataInicio) : undefined,
    dataFim: dataFim ? paraDiaCivil(dataFim) : undefined,
    condicoes: condicoes.map(({ rotulo, id, ...condicao }: any) => condicao),
    // Chave opcional em branco não vai no payload (o campo é opcional, não "vazio").
    valores: Object.entries(valores)
      .filter(
        ([, valor]) =>
          typeof valor === 'boolean' ||
          (valor !== undefined && valor !== null && String(valor).trim() !== '')
      )
      .map(([chave, valor]) => ({
        chave,
        valor: typeof valor === 'boolean' ? (valor ? 'S' : 'N') : String(valor)
      }))
  }
}
